// extracted by mini-css-extract-plugin
export default {"searchField":"PP-z","searchTextField":"QP-z"};